import { render, staticRenderFns } from "./screen_video.vue?vue&type=template&id=246f5b40&scoped=true&"
import script from "./screen_video.vue?vue&type=script&lang=js&"
export * from "./screen_video.vue?vue&type=script&lang=js&"
import style0 from "./screen_video.vue?vue&type=style&index=0&id=246f5b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f5b40",
  null
  
)

export default component.exports